import React, { FC, HTMLAttributes } from 'react'
import { cn } from '../utils/cn'

export const Skeleton: FC<HTMLAttributes<HTMLDivElement>> = ({
  className,
  ...restProps
}) => {
  return (
    <div
      aria-hidden="true"
      className={cn('h-4 w-full animate-pulse rounded bg-slate-300', className)}
      {...restProps}
    />
  )
}
